window.onload = function() {
    window.location.hash = '#catalog';
}

const prevBtn = document.querySelector("#prev-btn");
const nextBtn = document.querySelector("#next-btn");
const prevBtnMobile = document.querySelector("#prev-btn-mobile");
const nextBtnMobile = document.querySelector("#next-btn-mobile");

const book = document.querySelector("#book");

const catalogWrapper = document.querySelector(".catalog-wrapper");

// Event Listener
prevBtn.addEventListener("click", goPrevPage);
nextBtn.addEventListener("click", goNextPage);

prevBtnMobile.addEventListener("click", goPrevPage);
nextBtnMobile.addEventListener("click", goNextPage);

// Business Logic
let currentLocation = 0;
let allPapers = document.getElementsByClassName('paper')
let numOfPapers = allPapers.length;
let maxLocation = allPapers.length - 1;

function openBook(isAtBeginning) {
    if (window.innerWidth <= 775) {
        if (isAtBeginning) {
            book.classList.add("translateX100");
            book.classList.remove("translateX0");
            book.classList.remove("translateX50");
        } else {
            book.classList.add("translateX0");
            book.classList.remove("translateX100");
            book.classList.remove("translateX50");
        }
        
        
    } else {
        book.classList.add("translateX50");
        book.classList.remove("translateX100");
        book.classList.remove("translateX0");
    }
    prevBtn.classList.add("left-button-slide");
    nextBtn.classList.add("right-button-slide");
}

function closeBook(isAtBeginning) {
    if(isAtBeginning) {
        book.classList.add("translateX0");
        book.classList.remove("translateX50");
        book.classList.remove("translateX100");
    } else {
        book.classList.add("translateX100");
        book.classList.remove("translateX50");
        book.classList.remove("translateX0");
    }

    prevBtn.classList.remove("left-button-slide");
    nextBtn.classList.remove("right-button-slide");
}

const windowGlow = document.getElementById('window-glow')

function goNextPage() {
    if(currentLocation <= maxLocation) {

        if (window.innerWidth <= 775) {

            if (book.classList.contains('translateX100')) {
                book.classList.remove("translateX100");
                book.classList.remove("translateX50");
                book.classList.add("translateX0");
                return
            } else {
                book.classList.remove("translateX0");
                book.classList.remove("translateX50");
                book.classList.add("translateX100");
            }
            
        }


        switch(currentLocation) {
            case 0:
                openBook(true);
                allPapers[0].classList.remove("flippedBack");
                allPapers[0].classList.add("flipped");
                break;
            case maxLocation:
                allPapers[maxLocation].classList.remove("flippedBack");
                allPapers[maxLocation].classList.add("flipped");
                closeBook(false);
                break;
            default:
                allPapers[currentLocation].classList.remove("flippedBack");
                allPapers[currentLocation].classList.add("flipped");
                break;
        }
        currentLocation++;
    }
}

function goPrevPage() {
    if(currentLocation > 0) {

        if (window.innerWidth <= 775) {

            if (book.classList.contains('translateX100')) {
                book.classList.remove("translateX100");
                book.classList.add("translateX0");
            } else {
                book.classList.remove("translateX0");
                book.classList.add("translateX100");
                return
            }
        }


        switch(currentLocation) {
            case 1:
                closeBook(true);
                allPapers[0].classList.remove("flipped");
                allPapers[0].classList.add("flippedBack");
                break;
            case maxLocation + 1:
                openBook(false);
                allPapers[maxLocation].classList.remove("flipped");
                allPapers[maxLocation].classList.add("flippedBack");
                break;
            default:
                allPapers[currentLocation - 1].classList.remove("flipped");
                allPapers[currentLocation - 1].classList.add("flippedBack");
                break;
        }

        currentLocation--;
    }
}




const page1 = document.getElementById('p1')
const extraSteams = document.querySelectorAll(".steam:not(.steam1,.first-steam)");

page1.addEventListener('animationstart', function() {
    
    var theStyle;

    if (page1.classList.contains('flipped')) {
        theStyle = 'none'
    } else {
        theStyle = 'flex'
    }

    for(var i = 0; i < extraSteams.length; i++)
    {
        extraSteams[i].style.display = theStyle;
    }

})

const logoVideo = document.getElementById('logo-video-2025')

page1.addEventListener('animationend', function() { 
    if (event.animationName == 'flipAnimation') {

        $(logoVideo).fadeIn(300)
        try {
          logoVideo.play()
        } catch (error) {
          console.error(error);
        }
        
        
    }
    
})

page1.addEventListener('animationstart', function(event) { 
    if (event.animationName == 'flipAnimationBack') {

        $(logoVideo).hide()
        
    }
})



const page2 = document.getElementById('p2')
const billNyeTotalVideo = document.getElementById('bill-nye-2025-video')

page2.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimation') {

        $(logoVideo).hide()
        
    }

    if (event.animationName == 'flipAnimationBack') {

        $(billNyeTotalVideo).hide()
        $('#bill-nye-science-kit-btn-2025').hide()
        $('#bill-nye-space-lab-btn-2025').hide()
        
    }
})


page2.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimation') {

        $(billNyeTotalVideo).fadeIn(300)
        try {
          billNyeTotalVideo.play()
        } catch (error) {
          console.error(error);
        }
        $('#bill-nye-science-kit-btn-2025').fadeIn(300)
        $('#bill-nye-space-lab-btn-2025').fadeIn(300)
        
    }

    if (event.animationName == 'flipAnimationBack') {

        $('#bill-nye-science-kit-btn-2025').hide()
        $('#bill-nye-space-lab-btn-2025').hide()
        
    }

})


const page3 = document.getElementById('p3')

page3.addEventListener('animationstart', function(event) {

    if (event.animationName == 'flipAnimation') {

        $(billNyeTotalVideo).hide()
        $('#bill-nye-science-kit-btn-2025').hide()
        $('#bill-nye-space-lab-btn-2025').hide()

    }

    if (event.animationName == 'flipAnimationBack') {

        $(scienceSquadTotal).hide()

    }

})



const scienceSquadTotal = document.getElementById('scienceSquad-video-2025')



page3.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimation') {
        $(scienceSquadTotal).fadeIn(300);
        try {
          scienceSquadTotal.play();
        } catch (error) {
          console.error(error);
        }
        $('#bill-nye-weather-lab-btn-2025').fadeIn(300)
        $('#bill-nye-chem-lab-btn-2025').fadeIn(300)
        $('#bill-nye-body-lab-btn-2025').fadeIn(300)
        $('#bill-nye-rocket-lab-btn-2025').fadeIn(300)
    }

    if (event.animationName == 'flipAnimationBack') {

        $(scienceSquadTotal).hide()
        $('#bill-nye-weather-lab-btn-2025').hide()
        $('#bill-nye-chem-lab-btn-2025').hide()

        $('#bill-nye-science-kit-btn-2025').fadeIn(300)
        $('#bill-nye-space-lab-btn-2025').fadeIn(300)

    }
})

const page4 = document.getElementById('p4')
const realSteams = document.querySelectorAll(".steam1,.first-steam");
const atlasVideo = document.getElementById('atlas-video-2025')

page4.addEventListener('animationend', function(event) {
    // document.getElementById('atlas-video').play();
    if (event.animationName == 'flipAnimation') {
        $(atlasVideo).fadeIn(300);
        try {
          atlasVideo.play();
        } catch (error) {
          console.error(error);
        }
        $('#pmax-atlas-btn-2025').fadeIn(300)
    }

    if (event.animationName == 'flipAnimationBack') {
        $('#bill-nye-weather-lab-btn-2025').fadeIn(300)
        $('#bill-nye-chem-lab-btn-2025').fadeIn(300)
        $('#bill-nye-body-lab-btn-2025').fadeIn(300)
        $('#bill-nye-rocket-lab-btn-2025').fadeIn(300)
    }
})


page4.addEventListener('animationstart', function(event) {
    var theStyle;

    if (!page4.classList.contains('flippedBack') && page4.classList.contains('flipped')) {
        theStyle = 'none'
    } else {
        theStyle = 'flex'
    }


    for(var i = 0; i < realSteams.length; i++)
    {
        realSteams[i].style.display = theStyle;
    }
    

    if (event.animationName == 'flipAnimation') {

        $(scienceSquadTotal).hide()
        $('#bill-nye-weather-lab-btn-2025').hide()
        $('#bill-nye-chem-lab-btn-2025').hide()
        $('#bill-nye-body-lab-btn-2025').hide()
        $('#bill-nye-rocket-lab-btn-2025').hide()

    }

    if (event.animationName == 'flipAnimationBack') {

        $(scienceSquadTotal).hide()
        $(atlasVideo).hide()
        $('#pmax-atlas-btn-2025').hide()
        $('#bill-nye-weather-lab-btn-2025').hide()
        $('#bill-nye-chem-lab-btn-2025').hide()
        $('#bill-nye-body-lab-btn-2025').hide()
        $('#bill-nye-rocket-lab-btn-2025').hide()

    }

})

















const page5 = document.getElementById('p5')
const masterChefVideo = document.getElementById('masterchef-video-2025')

page5.addEventListener('animationstart', function(event) {
    
    if (event.animationName == 'flipAnimation') {
        $(atlasVideo).hide()
        $('#pmax-atlas-btn-2025').hide()
    }

    if (event.animationName == 'flipAnimationBack') {
        $(masterChefVideo).hide();
        $('#masterchef-btn-2025').hide()
    }
})


page5.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimationBack') {
        $(masterChefVideo).hide();
        $('#pmax-atlas-btn-2025').fadeIn(300)
    }
    if (event.animationName == 'flipAnimation') {
        $(masterChefVideo).fadeIn(300);
        try {
          masterChefVideo.play();
        } catch (error) {
          console.error(error);
        }
        $('#masterchef-btn-2025').fadeIn(300)
    }
})



const page6 = document.getElementById('p6')
const pennAndTellerVideo = document.getElementById('penn-teller-video-2025')

page6.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimation' || event.animationName == 'flipAnimationBack') {
        $(masterChefVideo).hide();
        $('#masterchef-btn-2025').hide()
        
    }
    if (event.animationName == 'flipAnimationBack') {
        $(pennAndTellerVideo).hide();
        $('#penn-teller-magic-btn-2025').hide()
    }
})

page6.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimationBack') {
        $('#masterchef-btn-2025').fadeIn(300)
    }
    if (event.animationName == 'flipAnimation') {
        $(pennAndTellerVideo).fadeIn(300);
        try {
          pennAndTellerVideo.play();
        } catch (error) {
          console.error(error);
        }
        $('#penn-teller-magic-btn-2025').fadeIn(300)
    }
})



const page7 = document.getElementById('p7')
const espnVideo = document.getElementById('espn-transport-video-2025')

page7.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimationBack') {

        $(espnVideo).hide()
        $('#espn-btn-2025').hide()
        
    }
    if (event.animationName == 'flipAnimation') {

        $(pennAndTellerVideo).hide();
        $('#penn-teller-magic-btn-2025').hide()
        
    }
})

page7.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimation') {

        $(espnVideo).fadeIn(300)
        try {
          espnVideo.play()
        } catch (error) {
          console.error(error);
        }
        $('#espn-btn-2025').fadeIn(300)
        
    }

    if (event.animationName == 'flipAnimationBack') {

        $('#penn-teller-magic-btn-2025').fadeIn(300)
        
    }
})


const page8 = document.getElementById('p8')
const artHistoryVideo = document.getElementById('art-history-2025-video')

page8.addEventListener('animationstart', function(event) {

    if (event.animationName == 'flipAnimationBack' || event.animationName == 'flipAnimation') {

        $(espnVideo).hide()
        // $('#penn-teller-magic-btn').hide()

    }

    if (event.animationName == 'flipAnimation') {

        $('#espn-btn-2025').hide()

    }

    if (event.animationName == 'flipAnimationBack') {

        $(artHistoryVideo).hide()
        $('#history-btn-2025').hide()
        
    }

})

page8.addEventListener('animationend', function(event) {

    if (event.animationName == 'flipAnimationBack') {

        $(espnVideo).fadeIn(300)
        try {
          espnVideo.play()
        } catch (error) {
          console.error(error);
        }

        $('#espn-btn-2025').fadeIn(300)

    }

    if (event.animationName == 'flipAnimation') {

        $(artHistoryVideo).fadeIn(300)
        try {
          artHistoryVideo.play()
        } catch (error) {
          console.error(error);
        }
        $('#history-btn-2025').fadeIn(300)
        
    }

})



const page9 = document.getElementById('p9')
const DKVideo = document.getElementById('dk-video-2025')

page9.addEventListener('animationstart', function(event) {

    if (event.animationName == 'flipAnimation') {
        $(artHistoryVideo).hide()
        $('#history-btn-2025').hide()
    }

    if (event.animationName == 'flipAnimationBack') {
        $(DKVideo).hide();
        $('#dk-dino-btn-2025').hide()
        $('#dk-animals-btn-2025').hide()
        $('#dk-oceans-btn-2025').hide()
    }
})


page9.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimationBack') {
        $(DKVideo).hide();
        $(artHistoryVideo).fadeIn(300);
        try {
          artHistoryVideo.play();
        } catch (error) {
          console.error(error);
        }
        $('#history-btn-2025').fadeIn(300)
    }
    if (event.animationName == 'flipAnimation') {
        $(DKVideo).fadeIn(300);
        try {
          DKVideo.play();
        } catch (error) {
          console.error(error);
        }
        $('#dk-dino-btn-2025').fadeIn(300)
        $('#dk-animals-btn-2025').fadeIn(300)
        $('#dk-oceans-btn-2025').fadeIn(300)
    }
})




const page10 = document.getElementById('p10')
const steaLabTotal = document.getElementById('steamLabTotal-video-2025')

page10.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimationBack') {

        $(steaLabTotal).hide()
        $('#shark-lab-btn-2025').hide()
        $('#dino-dig-btn-2025-spec').hide()
        
    }

    if (event.animationName == 'flipAnimation' || event.animationName == 'flipAnimationBack') {
        $(DKVideo).hide();
        $('#dk-dino-btn-2025').hide()
        $('#dk-animals-btn-2025').hide()
        $('#dk-oceans-btn-2025').hide()
    }
})


page10.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimation') {

        $(steaLabTotal).fadeIn(300)
        try {
          steaLabTotal.play()
        } catch (error) {
          console.error(error);
        }
        $('#solar-system-btn-2025').fadeIn(300)
        $('#volcano-lab-btn-2025').fadeIn(300)
        $('#dino-dig-btn-2025').fadeIn(300)
        $('#shark-lab-btn-2025').fadeIn(300)
        $('#dino-dig-btn-2025-spec').fadeIn(300)
    }

    if (event.animationName == 'flipAnimationBack') {
        $('#dk-dino-btn-2025').fadeIn(300)
        $('#dk-animals-btn-2025').fadeIn(300)
        $('#dk-oceans-btn-2025').fadeIn(300)
    }

})



































const page11 = document.getElementById('p11')
const coldCaseVidTotal = document.getElementById('cold-case-video-2025')

page11.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimationBack' || event.animationName == 'flipAnimation') {
        $(steaLabTotal).hide()
        $('#shark-lab-btn-2025').hide()
        $('#dino-dig-btn-2025-spec').hide()
    }

    if (event.animationName == 'flipAnimationBack') {
        $(coldCaseVidTotal).hide()
        $('#cold-case-btn-2025').hide()
    }

})

page11.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimationBack') {

        $('#shark-lab-btn-2025').fadeIn(300)
        $('#dino-dig-btn-2025-spec').fadeIn(300)
       

    }

    if (event.animationName == 'flipAnimation') {
        $(coldCaseVidTotal).fadeIn(300)
        try {
          coldCaseVidTotal.play()
        } catch (error) {
          console.error(error);
        }
        $('#cold-case-btn-2025').fadeIn(300)
    }

})



const page12 = document.getElementById('p12')
const pixicadeVideoTotal = document.getElementById('pixicade-video-2025')

page12.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimation') {
        $(coldCaseVidTotal).hide()
        $('#cold-case-btn-2025').hide()
    }

    if (event.animationName == 'flipAnimationBack') {
        $(pixicadeVideoTotal).hide()
        $(coldCaseVidTotal).hide()
        $('#cold-case-btn-2025').hide()
    }
})



page12.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimation') {
        $(pixicadeVideoTotal).fadeIn(300)
        try {
          pixicadeVideoTotal.play()
        } catch (error) {
          console.error(error);
        }
    }
    if (event.animationName == 'flipAnimationBack') {
        $('#cold-case-btn-2025').fadeIn(300)
    }
})





























const page13 = document.getElementById('p13')
const holotoyzVideo = document.getElementById('holotoyz-video-2025')

if (holotoyzVideo) {
  holotoyzVideo.addEventListener('ended', function() {
      $('#holotoyz-tattoos-btn-2025').fadeIn(300)
      $('#holotoyz-stickers-btn-2025').fadeIn(300)
      $('#holotoyz-book-btn-2025').fadeIn(300)
      $(holotoyzVideo).fadeOut(300)
  });
}

page13.addEventListener('animationstart', function(event) {
    $(pixicadeVideoTotal).hide()
    if (event.animationName == 'flipAnimationBack') {
        $(holotoyzVideo).hide();
        $('#holotoyz-tattoos-btn-2025').hide()
        $('#holotoyz-stickers-btn-2025').hide()
        $('#holotoyz-book-btn-2025').hide()
    }
})



page13.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimationBack') {
        $(holotoyzVideo).hide();
    }
    if (event.animationName == 'flipAnimation') {
        $(holotoyzVideo).fadeIn(300);
        try {
          holotoyzVideo.play();
        } catch (error) {
          console.error(error);
          $('#holotoyz-tattoos-btn-2025').fadeIn(300)
          $('#holotoyz-stickers-btn-2025').fadeIn(300)
          $('#holotoyz-book-btn-2025').fadeIn(300)
        }
    }
})






const page14 = document.getElementById('p14')


page14.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimation') {
        $(holotoyzVideo).hide();
        $('#holotoyz-tattoos-btn-2025').hide()
        $('#holotoyz-stickers-btn-2025').hide()
        $('#holotoyz-book-btn-2025').hide()
    }
})


page14.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimationBack') {
        $('#holotoyz-tattoos-btn-2025').fadeIn(300)
        $('#holotoyz-stickers-btn-2025').fadeIn(300)
        $('#holotoyz-book-btn-2025').fadeIn(300)
    }
})

























const page15 = document.getElementById('p15')
const backlistVideo = document.getElementById('backlist-video-2025')


page15.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimationBack') {
        $(backlistVideo).hide();
        $('#pmax-science-2025').hide()
        $('#pmax-junior-chef-2025').hide()
        $('#pmax-universe-2025').hide()
    }
})



page15.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimationBack') {
        $(backlistVideo).hide();
    }
    if (event.animationName == 'flipAnimation') {
        $(backlistVideo).fadeIn(300);
        try {
          backlistVideo.play();
        } catch (error) {
          console.error(error);
        }
        $('#pmax-science-2025').fadeIn(300)
        $('#pmax-junior-chef-2025').fadeIn(300)
        $('#pmax-universe-2025').fadeIn(300)
    }
})


const page16 = document.getElementById('p16')

const lastPageVidTotal = document.getElementById('lastPageTotal-video')

page16.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimation') {
        $(backlistVideo).hide();
        $('#pmax-science-2025').hide()
        $('#pmax-junior-chef-2025').hide()
        $('#pmax-universe-2025').hide()
    }

    if (event.animationName == 'flipAnimationBack') {

        $(lastPageVidTotal).hide()

    }
})

page16.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimation') {

        $(lastPageVidTotal).fadeIn(300)

        try {
          lastPageVidTotal.play()
        } catch (error) {
          console.error(error);
        }

    }
    if (event.animationName == 'flipAnimationBack') {

        $('#pmax-science-2025').fadeIn(300)
        $('#pmax-junior-chef-2025').fadeIn(300)
        $('#pmax-universe-2025').fadeIn(300)

    }
})

const page17 = document.getElementById('p17')

page17.addEventListener('animationend', function(event) {
    if (event.animationName == 'flipAnimation') {
        catalogWrapper.style.overflow = 'hidden'
    } 
})

page17.addEventListener('animationstart', function(event) {
    if (event.animationName == 'flipAnimation') {
        $(lastPageVidTotal).hide()
    }

    if (event.animationName == 'flipAnimationBack') {
        catalogWrapper.style.overflow = ''
        $(lastPageVidTotal).hide()
    } 
})

